export const COMPONENT_UPLOADER_ROLE = "uploader";
